export default __webpack_public_path__ + "ff0d33a41f8fb4317a48e1baa9a112f9.png";